import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig, getShowByFolder } from '../util';
import { getIn18Text } from 'api';
import { getMailFromMails } from '@web-mail/util';
import { apis, apiHolder } from 'api';
import { FLOLDER } from '@web-mail/common/constant';
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const MailMultOperPanelConfig = [
    {
        key: MAIL_MENU_ITEM.MARK,
        group: '1',
        name: getIn18Text('BIAOJIWEI'),
        icon: undefined,
        onlyUnfold: true,
        show: mails => {
            return true;
        },
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.RED_FLAG,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.READ,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.TAG,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.WMFOLLOW_STATIC,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.WM_UNFOLLOW_STATIC,
                icon: undefined,
                group: '2',
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.MOVE,
        icon: undefined,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        icon: undefined,
        group: '1',
        show: (mails, defaultShowFn) => {
            const mail = getMailFromMails(mails);
            if (getShowByFolder(mail, [FLOLDER.ADVITISE, FLOLDER.SPAM])) {
                return false;
            }
            return !!defaultShowFn && defaultShowFn(mail);
        },
    },
    {
        key: MAIL_MENU_ITEM.DELETE_WRAP,
        icon: undefined,
        group: '1',
        name: getIn18Text('SHANCHU'),
        onlyUnfold: true,
        show: mails => {
            const mail = getMailFromMails(mails);
            if (getShowByFolder(mail, [FLOLDER.ADVITISE, FLOLDER.SPAM])) {
                return true;
            }
            return false;
        },
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.DELETE,
                icon: undefined,
                group: '1',
            },
            {
                key: MAIL_MENU_ITEM.DIRECT_DELETE,
                icon: undefined,
                group: '1',
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.TOP,
        icon: undefined,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.FORWARD_BY_ATTACH,
        icon: undefined,
        group: '1',
        show: (mails, defaultShow) => {
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            if (isThread) {
                return false;
            }
            return !!defaultShow && defaultShow(mail);
        },
    },
    {
        key: MAIL_MENU_ITEM.EXPORT,
        icon: undefined,
        group: '1',
        show: (mails, defaultShow) => {
            const mail = getMailFromMails(mails);
            const { isThread } = mail;
            if (isThread) {
                return false;
            }
            return !!defaultShow && defaultShow(mail);
        },
    },
];
export default findAndMergeDefaultMenuConfig(MailMultOperPanelConfig, DefaultMailMenuConfig);
